module.exports = __webpack_public_path__ + "img/99.e5201c74.jpg";